/**
 * Logger structuré uniformisé pour les warnings/erreurs runtime.
 *
 * Écrit dans la console du navigateur, préfixé par le scope. Le cockpit n'envoie plus rien à Sentry
 * depuis le 27/10/2026 : son bruit et ses sessions rejouées saturaient le compte. `logInfo`, simple
 * fil d'Ariane, ne s'affiche qu'en dev.
 *
 * Usage :
 *   logWarn('offline', 'mutation dropped after 5 attempts', { item })
 *   logError('push', 'subscription failed', err, { userId })
 *
 * CLAUDE.md : "erreurs taguées avec contexte (user_id, account_id, request_id)".
 */

export type LogScope = 'offline' | 'push' | 'sw' | 'geo' | 'badging' | 'media' | 'realtime' | 'ai-usage' | 'relations' | 'backlog' | 'home' | 'travail' | 'equipe' | 'organization' | 'appointments' | 'events' | 'revenue' | 'editorial' | 'business-case' | 'robot-terms' | 'crm' | 'access' | 'companies' | 'presentation';

interface LogContext {
  readonly [key: string]: unknown;
}

const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV === true;

export function logWarn(scope: LogScope, message: string, context?: LogContext): void {
  console.warn(`[${scope}] ${message}`, context ?? '');
}

export function logError(
  scope: LogScope,
  message: string,
  err: unknown,
  context?: LogContext,
): void {
  console.error(`[${scope}] ${message}`, err, context ?? '');
}

export function logInfo(scope: LogScope, message: string, context?: LogContext): void {
  if (!isDev) return;
  console.info(`[${scope}] ${message}`, context ?? '');
}
